import dayjs from 'dayjs'
import { PreparationType } from '@/models/room-manager/response/guest-room-indicator'

/** 一括操作の対象期間上限。SC側の在庫保持期間に合わせているため両操作で共通 */
export const BULK_OPERATION_MAX_MONTHS = 6

export const PREPARATION_MEMO_MAX_LENGTH = 100

export type BulkOperationPeriodType = {
  beginDate: string
  endDate: string
}

export type SiteControllerStockBulkUpdateRequestType = BulkOperationPeriodType

export type PreparationBulkCreateRequestType = BulkOperationPeriodType & {
  preparationType: PreparationType
  /** 指定タイプに属する全客室が対象。客室単位の指定は行わない */
  roomTypeIds: string[]
  preparationMemo: string
}

/** 期間に含まれる日数（両端を含む） */
export const countBulkOperationPeriodDays = ({ beginDate, endDate }: BulkOperationPeriodType): number => {
  if (!beginDate || !endDate) return 0
  return dayjs(endDate).diff(dayjs(beginDate), 'day') + 1
}
